export default function formatNumber(num?: number | string): string {
  return Number.isNaN(num)
    ? ''
    : String(num).replace(/\B(?=(\d{3})+(?!\d))/g, " ");    
}